import { Provider } from 'react-redux';
import { createReduxWrapper } from '@doda/common/src/redux/utils/createReduxWrapper';
import { BasicLayout } from 'components/layouts/BasicLayout';
import { FC } from 'react';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import {
  CareerRecommendJobListScreen,
  CareerRecommendJobListScreenProps,
} from './screens/CareerRecommendJobListScreen';
import { reducer } from './redux/store';
import { initServerSideProps } from './initServerSideProps';

/**
 * CareerRecommendJobListページのProps
 */
export interface CareerRecommendJobListPageProps {
  pageProps: CareerRecommendJobListScreenProps & {
    /** リード文 */
    leadSentence: string;
  };
}

/**
 * CareerRecommendJobListコンポーネント
 *
 * @param {CareerRecommendJobListPageProps} pageProps - コンポーネントのプロパティ
 * @returns {JSX.Element} JSX要素
 */
const CareerRecommendJobList: FC<CareerRecommendJobListPageProps> = (
  pageProps
) => {
  const { store, props } = wrapper.useWrappedStore(pageProps);

  const {
    isShowAgentService,
    sideBarProps,
    modalMasterData,
    seoFooterLink,
    currentPage,
    leadSentence,
  } = props.pageProps;

  return (
    <Provider store={store}>
      <BasicLayout
        selectedNavItem={HEADER_NAV_MENU.SEARCH}
        leadSentence={leadSentence}
      >
        <CareerRecommendJobListScreen
          isShowAgentService={isShowAgentService}
          modalMasterData={modalMasterData}
          sideBarProps={sideBarProps}
          seoFooterLink={seoFooterLink}
          currentPage={currentPage}
        />
      </BasicLayout>
    </Provider>
  );
};

const wrapper = createReduxWrapper(reducer);

export const getServerSideProps =
  wrapper.getServerSideProps(initServerSideProps);

export default CareerRecommendJobList;
